export const sortCategoriesByOrder = <T extends { order: number }>(items: T[] | undefined): T[] =>
  [...(items ?? [])].sort((a, b) => a.order - b.order);
